<div class="tags-div">
  <div *ngFor="let tag of _tags | slice: 0 : 5">
    <div class="tags-div-tag">#{{ tag.label }}</div>
  </div>
</div>
